import {CurrentComicWidget} from "./widgets/current-comic";

export const widgets = {
  "xkcd:current-comic": CurrentComicWidget,
};
